import * as React from "react";
import { SVGProps } from "react";
const Plate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5956 7.52539C20.0764 8.17211 21.9118 10.4073 21.9118 13.0576C21.9118 15.5852 20.2426 17.735 17.9364 18.4892"
      stroke="currentColor"
      strokeWidth={1.9988}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2693 4.47469C14.1647 4.18512 15.1215 4.0293 16.1161 4.0293C21.1656 4.0293 25.2598 8.07093 25.2598 13.0558C25.2598 18.0406 21.1656 22.0822 16.1161 22.0822C13.4691 22.0822 11.0833 20.9708 9.41406 19.1961"
      stroke="currentColor"
      strokeWidth={1.9988}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.92871 1.91602V5.61706C1.92871 7.94882 3.07412 8.49212 5.42639 8.49212C7.77866 8.49212 8.92406 8.38181 8.92406 5.61706V1.91602"
      stroke="currentColor"
      strokeWidth={1.9988}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.42676 1.91602V21.5947"
      stroke="currentColor"
      strokeWidth={1.9988}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Plate;
